// assets
import SignInVec from "@assets/AuthPage/login.png"

export const LoginFormImage = () => (
    <span
        className="flex-grow bg-no-repeat bg-center bg-contain max-h-36 lg-tall:max-h-64 xl-tall:max-h-72 3xl-tall:max-h-80"
        style={{
            backgroundImage: `url(${SignInVec})`,
        }}
    />
)
